import { buttonCommonSX } from '@/components/blocks/DpLibrary/DpButton/style/button';
import { ButtonProps } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';
import { makeObject } from '@/utils/contentParsing';
import { UrlObject } from 'url';

interface DpButtonProps extends Omit<ButtonProps, 'variant' | 'size' | 'color' | 'href'> {
	href?: string | UrlObject;
	text?: string;
	underline?: 'none' | 'hover' | 'always';
	variant?: 'primary' | 'unfocused' | 'text' | 'outlined';
	size?: 'small' | 'default' | 'medium' | 'large';
	color?: 'default' | 'primary';
	target?: string;
}

export const DpButton: React.FC<React.PropsWithChildren<DpButtonProps>> = ({
	text,
	href,
	sx,
	children,
	type,
	variant = 'primary',
	size = 'medium',
	underline = 'hover',
	color = 'primary',
	component,
	disabled,
	...props
}) => (
	<Linkable
		{...props}
		href={href}
		type={variant === 'text' ? 'button-base' : 'button'}
		component={component ? component : href ? 'a' : 'button'}
		variant={variant === 'outlined' ? 'outlined' : 'contained'}
		disabled={disabled}
		buttonType={type}
		sx={combineSX([
			buttonCommonSX({ variant, size, underline, color, disabled }),
			...(Array.isArray(sx) ? sx : [makeObject(sx)]),
		])}
	>
		{text ?? children}
	</Linkable>
);
